
<div class="keys">
	@for (key of data.addKeys; track key) {

		<button type="button" class="btn btn-primary btn-lg btn-block add-key" (mousedown)="setAmaountKey(key)"
				[disabled]="key == null">
			{{ key }}
		</button>

	}
	@for (key of keys; track key) {
		<button type="button" mat-stroked-button color="accent" class="btn-block"
				(mousedown)="setAmaountKey(key)" [disabled]="key == null">
			<ng-container *ngIf="key === null">{{ key }}</ng-container>
			<ng-container *ngIf="key != 'back'">{{ key }}</ng-container>
			<ng-container *ngIf="key == 'back'">
				<mat-icon>backspace</mat-icon>
			</ng-container>
		</button>
	}
</div>


